// Neu laden, wenn ein anderer Service Worker die Seite übernimmt (#588).
//
// Der Update-Fluss (W6, #16 B5): Ein neuer Worker wartet, die App zeigt
// „Jetzt aktualisieren“, das schickt SKIP_WAITING, der neue Worker übernimmt
// per clients.claim(), und `controllerchange` lädt die Seite genau einmal neu.
//
// Beim allerersten Besuch (neues Gerät, neuer Browser, gelöschte Websitedaten)
// feuert `controllerchange` aber auch: Der erste Worker übernimmt per
// clients.claim() eine Seite, die noch gar keinen hatte. Bis v3.0 lud die Seite
// dann rund eine halbe bis zwei Sekunden nach dem Start ein zweites Mal, und ein
// in dieser Zeit geöffnetes Ticket (auch per Push-Klick mit ?openTicket=) war
// wieder weg. Neu geladen wird deshalb nur, wenn vorher schon ein Worker die
// Seite kontrolliert hat: Nur dann läuft womöglich alter Code.
export function erstelleNeuLadenBeiWechsel(serviceWorker, neuLaden) {
  let bisher = serviceWorker.controller || null;
  let schonNeuGeladen = false;
  return () => {
    const vorher = bisher;
    bisher = serviceWorker.controller || null;
    if (!vorher) return false;
    if (schonNeuGeladen) return false;
    schonNeuGeladen = true;
    neuLaden();
    return true;
  };
}
